<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  [ngStyle]="overrideStyle"
>
  <path
    d="M8.71704 10.2668C8.71704 9.87036 8.86743 9.5673 9.16821 9.35767C9.46444 9.14803 9.89738 9.04321 10.467 9.04321V7.40942C9.89282 7.40942 9.4576 7.30916 9.16138 7.10864C8.86515 6.90812 8.71704 6.62101 8.71704 6.24731V6.19263V4.0188C8.71704 3.32153 8.49601 2.83162 8.05396 2.54907C7.6119 2.26196 6.83488 2.11841 5.7229 2.11841V3.65649C6.17407 3.67017 6.48625 3.75675 6.65942 3.91626C6.82804 4.07577 6.91235 4.31047 6.91235 4.62036V6.66431C6.9397 7.52108 7.4729 8.02694 8.51196 8.18188V8.26392C7.44556 8.42342 6.91235 8.90649 6.91235 9.71313V9.77466V11.8186C6.91235 12.1285 6.82804 12.3632 6.65942 12.5227C6.4908 12.6822 6.17863 12.7688 5.7229 12.7825V14.3274C6.83488 14.3274 7.6119 14.1838 8.05396 13.8967C8.49601 13.6142 8.71704 13.122 8.71704 12.4202V10.2668Z"
    fill="white"
  />
</svg>
